import {
  TALENT_LOADED,
  TALENT_ERROR,
  TALENT_SAVE_ERROR,
  TALENT_SAVE_SUCCESS,
  TALENT_OPPORTUNITIES_SAVE,
  TALENT_OPPORTUNITIES_EDIT,
  TALENT_OPPORTUNITIES_EDIT_ERROR,
  TALENT_OPPORTUNITIES_EDIT_SUCCESS,
  SINGLE_TALENT_LOAD,
  SINGLE_TALENT_LOADED,
} from '../constants';

export const talentLoaded = payload => ({
  type: TALENT_LOADED,
  payload,
});

export const talentError = payload => ({
  type: TALENT_ERROR,
  error: true,
  payload,
});

export const talentSaveSuccess = payload => ({
  type: TALENT_SAVE_SUCCESS,
  payload,
});

export const talentSaveError = payload => ({
  type: TALENT_SAVE_ERROR,
  error: true,
  payload,
});

export const talentOpportunitiesSave = payload => ({
  type: TALENT_OPPORTUNITIES_SAVE,
  payload,
});

export const talentOpportunitiesEdit = payload => ({
  type: TALENT_OPPORTUNITIES_EDIT,
  payload,
});

export const talentOpportunitiesEditSuccess = payload => ({
  type: TALENT_OPPORTUNITIES_EDIT_SUCCESS,
  payload,
});

export const talentOpportunitiesEditError = payload => ({
  type: TALENT_OPPORTUNITIES_EDIT_ERROR,
  error: true,
  payload,
});

export const getSingleTalent = payload => ({
  type: SINGLE_TALENT_LOAD,
  payload,
});

export const singleTalentLoaded = payload => ({
  type: SINGLE_TALENT_LOADED,
  payload,
});
